webpackJsonp([4],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("0ba48cc8", content, true, {});

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, ".manu{min-width:150px}.model{min-width:300px}.small-col{max-width:70px}", "", {"version":3,"sources":["/vue-ui/src/views/RimsAdmin.vue"],"names":[],"mappings":"AACA,MACE,eAAiB,CAClB,AACD,OACE,eAAiB,CAClB,AACD,WACE,cAAgB,CACjB","file":"RimsAdmin.vue","sourcesContent":["\n.manu {\n  min-width: 150px;\n}\n.model {\n  min-width: 300px;\n}\n.small-col {\n  max-width: 70px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-combobox',{attrs:{"label":"Manufacturer","items":_vm.manufacturers,"item-text":"name","item-value":"name"},model:{value:(_vm.editedItem.manufacturer),callback:function ($$v) {_vm.$set(_vm.editedItem, "manufacturer", $$v)},expression:"editedItem.manufacturer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Model"},model:{value:(_vm.editedItem.model),callback:function ($$v) {_vm.$set(_vm.editedItem, "model", $$v)},expression:"editedItem.model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.editedItem.weight),callback:function ($$v) {_vm.$set(_vm.editedItem, "weight", $$v)},expression:"editedItem.weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Diameter"},model:{value:(_vm.editedItem.diameter),callback:function ($$v) {_vm.$set(_vm.editedItem, "diameter", $$v)},expression:"editedItem.diameter"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-checkbox',{attrs:{"label":"Confirmed"},model:{value:(_vm.editedItem.confirmed),callback:function ($$v) {_vm.$set(_vm.editedItem, "confirmed", $$v)},expression:"editedItem.confirmed"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.loading,"color":"blue darken-1","flat":""},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.loading,"color":"blue darken-1","flat":""},on:{"click":_vm.saveRime}},[_vm._v("Save")]),_vm._v(" "),(_vm.editedIndex == -1)?_c('v-btn',{attrs:{"loading":_vm.loading,"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.saveRime(false)}}},[_vm._v("Save & next")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-btn',{on:{"click":_vm.editItem}},[_vm._v("Add New")]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.rims,"rows-per-page-items":_vm.rowsPerPage},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.manufacturer.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.model))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.weight))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.diameter))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.confirmed ? 'Coool' : 'no'))]),_vm._v(" "),_c('td',{},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("\n          edit\n        ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("\n          delete\n        ")])],1)]}},{key:"no-data",fn:function(){return [_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.fetchData}},[_vm._v("Reload")])]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RimsAdmin_vue__ = __webpack_require__(99);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740f0022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RimsAdmin_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RimsAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740f0022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RimsAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringMixin__["a" /* default */]],
  name: 'RimsAdmin',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('title-change', 'Admin - Rims');

    this.fetchData();
  },
  data: function data() {
    return {
      dialog: false,
      manufacturers: [],
      headers: [{
        text: 'Manufacturer', value: 'manufacturer.name', class: 'manu'
      }, {
        text: 'Model', value: 'model', class: 'model'
      }, {
        text: 'Weight', value: 'weight', class: 'small-col'
      }, {
        text: 'Diameter', value: 'diameter', class: 'small-col'
      }, {
        text: 'Confirmed', value: 'confirmed', class: 'small-col'
      }, { text: 'Actions', value: 'name', sortable: false }],
      rims: [],
      editedItem: {},
      rowsPerPage: [20, 50, 100, 500, 1000],
      loading: false,
      editedIndex: 0
    };
  },

  methods: {
    //'8d1dfe9c-78b8-4a44-bbc3-5a316f751ac2-62684042-2b11-4996-828b-683d89cc1604-8f4eeba7-c23f-4930-8695-b8e3e59257fd'
    fetchData: function fetchData() {
      var _this = this;

      fetch('https://be.mybikesetup.net/wheels/admin/rims', {
        headers: {
          'Content-Type': 'application/json',
          'XYZ-Admin-Token': this.$store.state.apiKey
        }
      }).then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        if (json != null) {
          _this.rims = json.rims;
        }
      });
      // fetch('https://be.mybikesetup.net/wheels/admin/rims', {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'XYZ-Admin-Token': '8d1dfe9c-78b8-4a44-bbc3-5a316f751ac2-62684042-2b11-4996-828b-683d89cc1604-8f4eeba7-c23f-4930-8695-b8e3e59257fd'
      //   }
      // }).then(response => response.ok ? response.json() : alert('mist')).then(json => {
      //   if (json != null) {
      //     this.rims = json.rims;
      //   }
      // });
    },
    editItem: function editItem(item) {
      var _this2 = this;

      fetch('https://be.mybikesetup.net/wheels/admin/manufacturers', {
        headers: {
          'XYZ-Admin-Token': this.$store.state.apiKey
        }
      }).then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        _this2.hubManufacturers = json || {};
      });
      this.editedIndex = this.rims.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      var _this3 = this;

      var index = this.rims.indexOf(item);
      confirm('Are you sure you want to delete this item?') && fetch('https://be.mybikesetup.net/wheels/admin/rims/' + item.id, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'XYZ-Admin-Token': this.$store.state.apiKey
        }
      }).then(function (response) {
        return response.ok ? _this3.rims.splice(index, 1) : alert('mist');
      });
    },
    saveRime: function saveRime(next) {
      var _this4 = this;

      if (this.editedItem.manufacturer.name) {
        this.editedItem.manufacturer = this.editedItem.manufacturer.name;
      }
      this.loading = true;
      fetch('https://be.mybikesetup.net/wheels/admin/rims/' + (this.editedItem.id == null ? '' : this.editedItem.id), {
        method: this.editedItem.id == null ? 'PUT' : 'POST',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editedItem),
        headers: {
          'Content-Type': 'application/json',
          'XYZ-Admin-Token': this.$store.state.apiKey
        }
      }).then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        if (json != null) {
          if (_this4.editedIndex != -1) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this4.hubs[_this4.editedIndex], json);
          } else {
            _this4.fetchData();
          }
          _this4.dialog = false;
          if (next != false) {
            _this4.dialog = false;
          }
        }
        _this4.loading = false;
      });
    },
    close: function close() {
      this.dialog = false;
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.3e107a408cfc4f82756d.js